import { postTransferStudents } from 'actions/classRoom';
import { fetchAutocompleteCoursesList, fetchCourseBatches } from 'actions/userManagementV2';
import { Modal, Select } from 'antd';
import { Button } from 'components/Button';
import { ModalSubTitle } from 'components/Typography';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Api } from 'services';

const {option} = Select

function TransferStudentModal({isTransferStudentVisible, setTransferStudentVisible, classes, selectedSection, postTransferStudents, togglePageLoader, getSubjStudentsData, selectedStudents, setSelectedStudents, autocompleteCoursesData, fetchAutocompleteCoursesList, fetchCourseBatches}) {
  const [selectedStd, setSelectedStd] = useState(null)
  const [selectedSec, setSelectedSec] = useState(null)
  const [transferLoader, serTransferLoader] = useState(false)
  const [targetStandard, setTargetStandard] = useState(null)
  // the class and section are picked from the chosen course's batches
  const [selectedCourse, setSelectedCourse] = useState(selectedSection?.courseId || null)
  const [courseBatches, setCourseBatches] = useState({})
  // live courses and batches any selected student already has
  const [takenCourseIds, setTakenCourseIds] = useState([])
  const [takenStandardIds, setTakenStandardIds] = useState([])

  useEffect(() => {
    fetchAutocompleteCoursesList({ emptySearch: true, names: true, fromCourse: true }, () => { })
    Promise.all((selectedStudents || []).map((userId) => new Promise((resolve) => {
      Api.get(`/user/get-student-course-details/${userId}`).send((response) => resolve(response))
    }))).then((details) => {
      setTakenCourseIds(details.flatMap((item) => (item?.userAssignedCourses || [])
        .filter((course) => course?.courseType === 'course').map((course) => course?.courseId)))
      setTakenStandardIds(details.flatMap((item) => (item?.studentClassDetails || []).map((std) => std?.standardId)))
    })
    // start from the course the students are already in
    if (selectedSection?.courseId) {
      fetchCourseBatches(selectedSection.courseId, (batches) => setCourseBatches(batches || {}))
    }
  }, [])

  // only a live course has batches, and only one with a batch can be transferred into
  // the current course stays, so they can move to another batch of it
  const liveCourses = autocompleteCoursesData?.filter(
    (item) => item?.itemType === 'course' && parseInt(item?.standardCount) > 0
      && (item?.itemId == selectedSection?.courseId || !takenCourseIds.some((id) => id == item?.itemId))
  ) || [];
  // show the course only once it is in the list, so the raw id never flashes
  const courseValue = liveCourses.find((item) => item?.itemId == selectedCourse)?.itemId;

  // sections the students are not in yet; a batch with none left is dropped
  const openSections = (batchName) => (courseBatches?.[batchName] || [])
    .filter((item) => item.id != selectedSection?.id && !takenStandardIds.some((id) => id == item.id));
  const openBatches = Object.keys(courseBatches).filter((batchName) => openSections(batchName).length > 0);

  const handleCancel = () => {
    setTransferStudentVisible(false)
  }
  const handleTransferClick = () => {
    const params = {
      targetStandard : selectedSec,
      students :selectedStudents
    }
    serTransferLoader(true);
    postTransferStudents(
      params,
      ()=>{serTransferLoader(false)},
      ()=>{
        setTransferStudentVisible(false);
        setSelectedStudents([])
        togglePageLoader(true);
        getSubjStudentsData(()=>togglePageLoader(false))
      }
      )
  }
  return (
    <div>
    <Modal
      centered
      className="modal-round-corner"
      visible={isTransferStudentVisible}
      onCancel={handleCancel}
      onOk={handleCancel}
      footer={null}>
      <div style={{ fontSize: "20px", color: "#191919", fontWeight: "bold", display: "flex", justifyContent: "center" }}>{"Transfer student(s)"}</div>
      <div style={{ padding: 20 }}>
        <ModalSubTitle>Course<span style={{ color: "red" }}> *</span></ModalSubTitle>
        <Select
          placeholder="Select course"
          style={{ width: "100%", marginBottom: 10 }}
          value={courseValue}
          onSelect={(value) => {
            setSelectedCourse(value);
            setSelectedStd(null);
            setSelectedSec(null);
            setCourseBatches({});
            fetchCourseBatches(value, (batches) => setCourseBatches(batches || {}));
          }}>
          {liveCourses?.map((item) => (
                    <Option key={item?.itemId} value={item?.itemId}>{item?.name}</Option>
                  ))}
        </Select>
        <ModalSubTitle>Batch<span style={{ color: "red" }}> *</span></ModalSubTitle>
        <Select
          placeholder="Select batch"
          notFoundContent="No batches found"
          style={{ width: "100%", marginBottom: 10 }}
          value={selectedStd}
          disabled={!selectedCourse}
          onSelect={(value) => {setSelectedStd(value); setSelectedSec(null);}}>
          {openBatches.map((item, index) => (
                    <Option key={item} value={item}>{item}</Option>
                  ))}
        </Select>
        <ModalSubTitle>Section<span style={{ color: "red" }}> *</span></ModalSubTitle>
        <Select
          placeholder="Select section"
          notFoundContent="No sections found"
          style={{ width: "100%", marginBottom: 10 }}
          value={selectedSec}
          disabled={!selectedStd}
          onSelect={(value) => {setSelectedSec(value)}} >
          { selectedStd && openSections(selectedStd).map((item, index) => (
                    <Option key={item.id} value={item.id}>{item.section}</Option>
                  ))}
        </Select>
        <div className='r-c-c m-t-40'>
          <Button
            loading={transferLoader}
            disabled={!selectedSec || !selectedStd}
            type="primary"
            onClick={handleTransferClick}
          >TRANSFER</Button>
        </div>
      </div>
    </Modal>
  </div>
  )
}
const mapStateToProps = state => {
  const {classes, selectedSection} = state.classRoom;
  const { autocompleteCoursesData } = state.userManagementV2;
  return {
    classes, selectedSection, autocompleteCoursesData
  };
};

const mapDispatchToProps = dispatch => ({
  postTransferStudents:(params, callBack, successCallBack) => dispatch(postTransferStudents(params, callBack, successCallBack)),
  fetchAutocompleteCoursesList: (params, callBack) => dispatch(fetchAutocompleteCoursesList(params, callBack)),
  fetchCourseBatches: (courseId, callBack) => dispatch(fetchCourseBatches(courseId, callBack))
});

export default connect(mapStateToProps, mapDispatchToProps)(TransferStudentModal);